import { BeltSyllabus } from './types';

export const greenBeltBlueTag: BeltSyllabus = {
    id: 'green-blue',
    name: 'Green Belt Blue Tag',
    color: '#008b8b',
    theoryUnder13: [
        {
            title: 'Theory',
            items: [
                {
                    question: 'What does Yul-Gok mean?',
                    answer: 'Yul-Gok is the pseudonym of the great philosopher and scholar Yi I (1536-1584), nicknamed the "Confucius of Korea". The 38 movements refer to his birthplace on 38 latitude, and the diagram represents "scholar".'
                },
                {
                    question: 'How many movements in Yul-Gok?',
                    answer: '38'
                },
                {
                    question: 'What is the diagram of Yul-Gok?',
                    answer: '/assets/diagrams/yul_gok_diagram.png',
                    isImage: true
                }
            ]
        },
        {
            title: 'Korean Terms',
            items: [
                { question: 'Low Stance', answer: 'Nat-chwo Sogi' },
                { question: 'X Stance', answer: 'Kyocha Sogi' },
                { question: 'Reverse Knifehand', answer: 'Sonkal Dung' },
                { question: 'Upper Elbow Strike', answer: 'Wi Palkup Taerigi' },
                { question: 'Palm Pressing Block', answer: 'Sonbadak Noollo Makgi' },
                { question: 'Twin Knifehand Block', answer: 'Sang Sonkal Makgi' },
                { question: 'Outward Waist Block', answer: 'Bakuro Hori Makgi' },
                { question: 'Outer Forearm Downward Block', answer: 'Bakat Palmok Naeryo Makgi' },
                { question: 'Sidefist Downward Strike', answer: 'Yop Joomok Naeryo Makgi' },
                { question: 'Knee Turning Kick', answer: 'Moorup Dollyo Chagi' },
                { question: 'Flying Turning Kick', answer: 'Twimyo Dollyo Chagi' }
            ]
        }
    ],
    theoryOver13: [
        {
            title: 'Theory',
            items: [
                {
                    question: 'What is the meaning of Yul-Gok?',
                    answer: 'Yul-Gok is the pseudonym of the great philosopher and scholar Yi I (1536-1584), nicknamed the "Confucius of Korea". The 38 movements refer to his birthplace on 38 latitude, and the diagram represents "scholar".'
                },
                {
                    question: 'Note',
                    answer: 'Note that "Yul-Gok" is pronounced "Yool-Gok"'
                },
                {
                    question: 'How many movements in Yul-Gok?',
                    answer: '38'
                },
                {
                    question: 'What is the diagram of Yul-Gok?',
                    answer: '/assets/diagrams/yul_gok_diagram.png',
                    isImage: true
                }
            ]
        },
        {
            title: 'Korean Terms',
            items: [
                { question: 'Low Stance', answer: 'Nat-chwo Sogi' },
                { question: 'Reverse Knifehand', answer: 'Sonkal Dung' },
                { question: 'Elbow', answer: 'Palkup' },
                { question: 'Upper Elbow Strike', answer: 'Wi Palkup Taerigi' },
                { question: 'Palm Pressing Block', answer: 'Sonbadak Noollo Makgi' },
                { question: 'Twin Knifehand Block', answer: 'Sang Sonkal Makgi' },
                { question: 'Outward Waist Block', answer: 'Bakuro Hori Makgi' },
                { question: 'Outer Forearm Downward Block', answer: 'Bakat Palmok Naeryo Makgi' },
                { question: 'Crescent Kick', answer: 'Bandal Chagi' },
                { question: 'Reverse Hooking Kick', answer: 'Bandae Dollyo Goro Chagi' },
                { question: 'Sidefist Downward Strike', answer: 'Yop Joomok Naeryo Makgi' },
                { question: 'Knee Turning Kick', answer: 'Moorup Dollyo Chagi' },
                { question: 'Flying Turning Kick', answer: 'Twimyo Dollyo Chagi' }
            ]
        }
    ],
    practical: [
        {
            title: 'Practical Elements',
            items: [
                {
                    question: 'L Stance Backfist Side Strike, Walking Stance Downward Release, Reverse High Punch',
                    answer: 'Forward X 4'
                },
                {
                    question: 'L Stance Knifehand Guarding Block, Walking Stance Upper Elbow Strike',
                    answer: 'Forward X 4'
                },
                {
                    question: 'L Stance Forearm Guarding Block, Low Stance Palm Pressing Block',
                    answer: 'Forward X 4'
                },
                {
                    question: 'Reverse Turning Kick, L Stance Forearm Guarding Block',
                    answer: 'Forward X 4'
                }
            ]
        },
        {
            title: 'Power',
            items: [
                {
                    question: 'Left and Right Turning Kick',
                    answer: '1 Board'
                },
                {
                    question: 'Flying Turning Kick',
                    answer: 'Target / Kick Shield'
                }
            ]
        },
        {
            title: 'Pattern',
            items: [
                {
                    question: 'Won-Hyo',
                    answer: ' '
                },
                {
                    question: 'Yul-Gok',
                    answer: ' '
                }
            ]
        },
        {
            title: 'Self Defence',
            items: [
                {
                    question: 'Choke Hold - front on from attacker',
                    answer: 'All Ages'
                },
                {
                    question: 'Waist Grab (Over Arms and Under Arms)',
                    answer: 'All Ages'
                },
                {
                    question: 'Situational - Knees and Elbows (Block / Dodge)',
                    answer: 'All Ages'
                }
            ]
        },
        {
            title: 'Sparring',
            items: [
                {
                    question: 'Two-Step Sparring',
                    answer: 'Sequences 1-5'
                },
                {
                    question: 'Free Sparring',
                    answer: 'Blocking, Dodging, Flying Punches and Blitz Attacks'
                }
            ]
        }
    ]
};
